module.exports = __webpack_public_path__ + "img/loginBackground.24c2903b.jpg";